.tip {
  align-items: center;
  background: var(--color-info);
  border: 1px solid var(--color-text);
  display: flex;
  gap: 0.625rem;
  margin: 1rem;
  padding: 1rem;
}

.icon {
  width: 200px;
}
